<template>
<div class="footer">
    Copyright @ 2012-2025 triplefireman 版权所有 &nbsp;&nbsp; <a href="http://triplefireman.com" target="_blank">triplefireman.com</a>
</div>
</template>

<script>
    export default{
        name: "FooterView",
    }
</script>

<style lang="scss" scoped>
.footer{
    padding:20px;
    display:flex;
    justify-content: center;
    align-items:center;
    height: 40px;
    font-size: 12px;
}
</style>